<script>
    import {isActive} from '../routes';

    export let assessment_id;
</script>

<p class="panel-tabs">
    <a class:is-active={isActive(`#/assessment/${assessment_id}/scope`)} href="#/assessment/{assessment_id}/scope">Scoping</a>
    <a class:is-active={isActive(`#/assessment/${assessment_id}`)} href="#/assessment/{assessment_id}">Assessment</a>
    <a class:is-active={isActive(`#/assessment/${assessment_id}/results`)} href="#/assessment/{assessment_id}/results">Results</a>
    <!--<a class:is-active={isActive(`#/assessment/${assessment_id}/review`)} href="#/assessment/{assessment_id}/review">Review</a>-->
    <a class:is-active={isActive(`#/assessment/${assessment_id}/report`)} href="#/assessment/{assessment_id}/report">Report</a>
</p>